export default __webpack_public_path__ + "static/media/element_34.cc08d079.jpg";